import React from "react";

export const displayDate = (value) => {
  if (!value) return "Тов зарлагдаагүй";
  const numeric = Number(value);
  const date = new Date(
    Number.isFinite(numeric) ? numeric * (numeric < 1e12 ? 1000 : 1) : value
  );
  return Number.isNaN(date.getTime())
    ? "Тов зарлагдаагүй"
    : date.toLocaleString("mn-MN");
};

export const TicketGroups = ({ tickets, sections = [] }) => {
  const groups = Object.values(
    tickets.reduce((result, ticket) => {
      const key = String(ticket.section_id);
      if (!result[key])
        result[key] = {
          section:
            ticket.section_name ||
            sections.find((section) => String(section.id) === key)
              ?.section_name ||
            `Сугалаа #${key}`,
          draw: ticket.draw_date,
          tickets: [],
        };
      result[key].tickets.push(ticket);
      return result;
    }, {})
  );
  return (
    <div className="mw-ticket-groups">
      {groups.map((group) => (
        <section key={group.tickets[0].section_id}>
          <h4>{group.section}</h4>
          <p className="megawin-checkout-note">
            Тохирол: {displayDate(group.draw)}
          </p>
          <ul>
            {group.tickets.map((ticket) => (
              <li key={ticket.id}>
                <strong>{ticket.lottery_number}</strong>
                {ticket.is_bonus_ticket && (
                  <span className="mw-bonus">Бонус</span>
                )}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
};

export default function CustomerDetails({
  customer,
  sections,
  onCheckTickets,
  busy,
}) {
  if (!customer) return null;
  const history = Array.isArray(customer.purchaseHistory)
    ? customer.purchaseHistory
    : [];
  const waiting = Array.isArray(customer.waitingTickets)
    ? customer.waitingTickets
    : [];
  return (
    <div className="mw-customer-details">
      <h3>Худалдан авалтын түүх</h3>
      {customer.historyScope === "browser" && (
        <p className="mw-scope-note">
          Зөвхөн энэ хөтөч дээр хийсэн худалдан авалтууд харагдана. Утасны
          дугаар оруулах нь нэвтрэх үйлдэл биш.
        </p>
      )}
      {history.length ? (
        <div className="mw-customer-table">
          <table>
            <thead>
              <tr>
                <th>Захиалгын дугаар</th>
                <th>Огноо</th>
                <th>Дүн</th>
                <th>Тасалбар</th>
              </tr>
            </thead>
            <tbody>
              {history.map((purchase) => (
                <tr key={purchase.id}>
                  <td>{purchase.checkout_id}</td>
                  <td>{displayDate(purchase.created_date)}</td>
                  <td>{Number(purchase.amount).toLocaleString("mn-MN")}₮</td>
                  <td>
                    <button
                      type="button"
                      className="megawin-orange-button"
                      disabled={busy}
                      onClick={() => onCheckTickets(purchase.checkout_id)}
                    >
                      Тасалбар шалгах
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="mw-empty">
          Төлөгдсөн худалдан авалт одоогоор байхгүй байна. Төлбөр баталгаажсаны
          дараа энд харагдана.
        </p>
      )}
      <h3>Удахгүй болох тохирлын тасалбарууд</h3>
      {waiting.length ? (
        <TicketGroups tickets={waiting} sections={sections} />
      ) : (
        <p className="mw-empty">
          Хүлээгдэж буй тохирлын тасалбар одоогоор байхгүй байна.
        </p>
      )}
    </div>
  );
}
